import Cookies from 'js-cookie'
import store from '@/store'
import { DOMAIN, WE_DOMAIN } from '@/config'
import storage from '@/utils/storage'
// 认证信息包括 token && 需要在发请求时带在 header 上
const TOKEN_KEY = 'ADMIN_TOKEN'
// 登录后的用户信息
const USER_KEY = 'USER_INFO'

const LAST_LOGIN_KEY = 'LAST_LOGIN'
// 用户权限信息
const FULLPATH_KEY = 'FULLPATH'

// 直播云官网登陆标志
const ISLIVE_KEY = 'FROM_WHERE'

// 获取是否是直播云官网
export function getIsLive () {
  return Cookies.get(ISLIVE_KEY)
}

const EXPIRES = 1 // 24 小时过期
export function getToken () {
  return Cookies.get(TOKEN_KEY)
}

// token 信息
export function setToken (token) {
  return Cookies.set(TOKEN_KEY, token, { expires: EXPIRES, domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}

export function removeToken (main) {
  let _main = main
  if (!_main) {
    _main = store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN
  }
  return Cookies.remove(TOKEN_KEY, { domain: _main })
}

// 登录用户基本信息
export function setUser (user, main) {
  let _main = main
  if (!_main) {
    _main = store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN
  }
  return Cookies.set(USER_KEY, user, { expires: EXPIRES, domain: _main })
}

/**
 * 获取用户信息
 * 具体用户信息在 services/auth/index.js login方法中设置
 * @param { String } key 可选，用户信息中的键值
 */
export function getUser (key = '') {
  var user = Cookies.getJSON(USER_KEY)
  return key && user ? user[key] : user || {}
}
// 获取合作模式
export function getCooperationType () {
  return Object.assign(
    {},
    JSON.parse(getUser().cooperation_type || '{}')
  )
}

// 删除用户信息
export function removeUser (main) {
  let _main = main
  if (!_main) {
    _main = store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN
  }
  return Cookies.remove(USER_KEY, { domain: _main })
}

// 判断用户是否登录
export function loggedIn () {
  return !!Cookies.get(TOKEN_KEY)
}

// 获取登录用户的角色字符串数组
// 目前只有 教务、教师
export function getRole () {
  return getUser().role_name || ''
}

// 保存上次登录的用户
export function setLastLoggedUser (user) {
  return Cookies.set(LAST_LOGIN_KEY, user, { expires: EXPIRES, domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}

// 获取上次登录的用户
export function getLastLoggedUser () {
  return Cookies.getJSON(LAST_LOGIN_KEY) || {}
}

// 清除上次登录的用户
export function clearLastLoggedUser () {
  return Cookies.remove(LAST_LOGIN_KEY, { domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}
// 获取登录来源
export function getFromUrl () {
  return Cookies.getJSON('FROM_URL') || ''
}
// 清除登录来源cookie
export function removeFromUrl () {
  return Cookies.remove('FROM_URL', { domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}
// 设置document title
export function setTitle (val) {
  document.title = val || '学校管理'
}
// 设置权限
export function setPermissions (permissions) {
  store.dispatch('setPermissions', permissions)
  window.pubSub.publish('permissions', permissions) // 发布permissions事件
  window.localStorage.setItem('permissions', JSON.stringify(permissions)) // 子项目需要从localStorage中获取
}
// 获取权限
export function getPermissions (key) {
  let permissions = store.getters.permissions
  return key && permissions ? permissions[key] || [] : permissions || []
}
// 清除权限
export function removePermissions () {
  store.dispatch('setPermissions', {})
}
// 设置路由
export function setFullPath (fullPath) {
  return Cookies.set(FULLPATH_KEY, fullPath, { expires: EXPIRES, domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}
// 获取已保存路由
export function getFullPath (key) {
  let fullPath = Cookies.getJSON(FULLPATH_KEY)
  return key && fullPath ? fullPath : ''
}
// 删除学校管理路由和删除教研教学路由
export function removeFullPath () {
  Cookies.remove(FULLPATH_KEY, { domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
  Cookies.remove('LMS_FULL_PATH', { domain: store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN })
}
export function parseUrlParams () {
  if (window.location.search.length <= 0) return {}
  var info = window.location.search.slice(1)
  var result = {}
  info.split('&').map(item => {
    result[decodeURIComponent(item.split('=')[0])] = decodeURIComponent(item.split('=')[1])
  })
  return result
}
// 获取是否有教研教学相关权限
export function getLearnPermissions () {
  return getPermissions('teaching_research').length > 1
}
// 获取是否有营销中心的相关权限
export function getMarketCenterPermissions () {
  return getPermissions('market_center').length > 0
}
// 是否是合作魔法校或者直播云
export function judgeContractType (type) {
  if (!type) {
    return 0
  }
  return store.getters.contract_types[type]
}

// 统一设置userInfo信息
export function unifySetUserInfo (userInfo) {
  let { id, name, role_name, school, avatar_url, cooperation_type, cooperation_type_record, country_code, country_id } = userInfo
  setUser({
    id,
    name,
    role_name,
    cooperation_type,
    school_id: school.id,
    school_name: school.name,
    school_short_name: school.short_name,
    third_part: school.third_part,
    is_self_live: school.is_self_live,
    avatar_url,
    is_teach: school.is_teach,
    is_content: school.is_content,
    permissions: school.permissions ? school.permissions : 'academic_affairs',
    is_live: school.is_live,
    is_zby: school.is_zby,
    is_contract_paid_exist: school.is_contract_paid_exist,
    cooperation_type_record: cooperation_type_record,
    is_wlhk_test: school.is_wlhk_test,
    country_code,
    country_id,
    is_personal: school.is_personal,
    certify_status: school.certify_status
  })
  // 子项目会从localStorage中取school信息
  storage.setItem('school', school)
}

export default {
  getIsLive,
  getToken,
  setToken,
  removeToken,
  setUser,
  getUser,
  removeUser,
  loggedIn,
  getRole,
  setLastLoggedUser,
  getLastLoggedUser,
  clearLastLoggedUser,
  getFromUrl,
  removeFromUrl,
  setTitle,
  setPermissions,
  getPermissions,
  removePermissions,
  getCooperationType,
  setFullPath,
  getFullPath,
  removeFullPath,
  getLearnPermissions,
  parseUrlParams,
  getMarketCenterPermissions,
  judgeContractType,
  unifySetUserInfo
}
